import { toast as _toast } from "react-hot-toast/headless";
import { FeaturedIcon, Toast } from "@kunduz/ui";
import WarningIcon from "@icons/warningIcon.svg";
import CheckmarkIcon from "@icons/checkVerifiedIcon.svg";
import InfoCircleIcon from "@icons/infoCircleIcon.svg";
import { v4 as uuidv4 } from "uuid";
import { ReactNode } from "react";

export function useToast(): IUseToastProps {
  function toastError(title: string | ReactNode, options?: ToastOptions) {
    const id = options?.id ?? uuidv4();
    _toast(
      <Toast
        title={title}
        desc={options?.desc}
        extraContent={options?.extraContent}
        actions={options?.actions}
        onClose={() => _toast.dismiss(id)}
        icon={
          options?.icon || (
            <FeaturedIcon color="red" size="md" theme="light-circle-outline">
              <WarningIcon />
            </FeaturedIcon>
          )
        }
      />,
      { duration: options?.autoClose || 5000, id },
    );
  }

  function toastSuccess(title: string | ReactNode, options?: ToastOptions) {
    const id = options?.id ?? uuidv4();
    _toast(
      <Toast
        title={title}
        desc={options?.desc}
        extraContent={options?.extraContent}
        actions={options?.actions}
        onClose={() => _toast.dismiss(id)}
        icon={
          options?.icon || (
            <FeaturedIcon
              color="success"
              size="md"
              theme="light-circle-outline"
            >
              <CheckmarkIcon />
            </FeaturedIcon>
          )
        }
      />,
      { duration: options?.autoClose || 5000, id },
    );
  }

  function toast(title: string | ReactNode, options?: ToastOptions) {
    const id = options?.id ?? uuidv4();
    _toast(
      <Toast
        title={title}
        desc={options?.desc}
        extraContent={options?.extraContent}
        actions={options?.actions}
        onClose={() => _toast.dismiss(id)}
        icon={
          options?.icon || (
            <FeaturedIcon
              color="primary"
              size="md"
              theme="light-circle-outline"
            >
              <InfoCircleIcon />
            </FeaturedIcon>
          )
        }
      />,
      { duration: options?.autoClose || 5000, id },
    );
  }

  function toastDismiss(id: string) {
    _toast.dismiss(id);
  }

  return { toast, toastSuccess, toastError, toastDismiss };
}

interface IUseToastProps {
  toast: (title: string | ReactNode, options?: ToastOptions) => void;
  toastError: (title: string | ReactNode, options?: ToastOptions) => void;
  toastSuccess: (title: string | ReactNode, options?: ToastOptions) => void;
  toastDismiss: (id: string) => void;
}

export interface ToastOptions {
  autoClose?: number;
  desc?: string;
  extraContent?: JSX.Element;
  actions?: JSX.Element;
  id?: string;
  icon?: JSX.Element;
}
